import { JgToPathNameMap } from './getApprovalConfig';
export const getJgToPathNameMap = {
    ...JgToPathNameMap,
};
